module.exports = __webpack_public_path__ + "images/family_2744ca7.svg";